import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { SdvorSharedCmsComponents } from '../cms-components.enum';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        CustomLinkModule: {
          module: () => import('./custom-link-lazy.module').then((m) => m.CustomLinkLazyModule),
          cmsComponents: [SdvorSharedCmsComponents.CMSLinkComponent],
        },
      },
    }),
  ],
})
export class CustomLinkModule {}
